
export interface Meme {
  id: string;
  title: string;
  imageUrl: string;
  author: string;
  votesFunny: number;
  votesSkjeta: number;
  comments: number;
  timestamp: string;
}

export interface Comment {
    id: string;
    content: string;
    author_name: string;
    author_avatar?: string;
    created_at: string;
    user_id: string;
}

export interface Badge {
  id: string;
  name: string;
  icon: string;
  description: string;
}

export type UserRole = 'admin' | 'moderator' | 'user';

export interface User {
  id: string;
  username: string;
  points: number;
  avatar: string;
  rank: number;
  streak: number;
  badges: string[]; // Array of badge IDs
  role: UserRole;
}

export enum ViewState {
  HOME = 'HOME',
  NEWS = 'NEWS',
  MEMES = 'MEMES',
  LEADERBOARD = 'LEADERBOARD',
  GAME = 'GAME',
  ORACLE = 'ORACLE',
  PROFILE = 'PROFILE',
  RULES = 'RULES',
  CONTACT = 'CONTACT',
  ADMIN = 'ADMIN',
  SKJETAPERSON = 'SKJETAPERSON',
  CONFESSIONS = 'CONFESSIONS',
  WIKI = 'WIKI'
}

export interface Challenge {
  title: string;
  description: string;
  difficulty: 'Lett' | 'Medium' | 'Total Skjeta';
}